import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

function VolunteerPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="container" style={{ padding: '80px 24px', maxWidth: '800px' }}>
        <button 
          className="btn btn-outline" 
          onClick={() => window.location.hash = ''}
          style={{ marginBottom: '40px' }}
        >
          ← Torna alla home
        </button>

        <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '16px' }}>Diventa Volontario</h1>
        <p className="section-subtitle" style={{ textAlign: 'left', margin: '0 0 48px 0', maxWidth: '100%' }}>
          Il nostro canile vive grazie al cuore e all'impegno di persone speciali. 
          Se hai del tempo libero e ami i cani, unisciti alla nostra famiglia! 
          Nessuna esperienza obbligatoria: ti insegneremo tutto noi passo dopo passo.
        </p>

        <div style={{ background: 'var(--color-bg-primary)', padding: '48px', borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-sm)' }}>
          <form onSubmit={(e) => { e.preventDefault(); alert("Candidatura inviata con successo! Ti contatteremo a breve."); window.location.hash = ''; }}>
            <div className="form-group" style={{ display: 'flex', gap: '20px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Nome e Cognome *</label>
                <input type="text" required placeholder="Es. Mario Rossi" />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Età *</label>
                <input type="number" required placeholder="Es. 25" min="18" />
              </div>
            </div>

            <div className="form-group" style={{ display: 'flex', gap: '20px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Email *</label>
                <input type="email" required placeholder="mario.rossi@email.com" />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Telefono *</label>
                <input type="tel" required placeholder="Il tuo numero" />
              </div>
            </div>

            <div className="form-group">
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Disponibilità settimanale *</label>
              <select style={{ width: '100%', padding: '16px', border: '1px solid #ddd', borderRadius: '12px', fontFamily: 'var(--font-secondary)' }} required>
                <option value="">Seleziona...</option>
                <option value="weekend">Solo Weekend</option>
                <option value="mattina">In settimana (Mattina)</option>
                <option value="pomeriggio">In settimana (Pomeriggio)</option>
                <option value="flessibile">Flessibile</option>
              </select>
            </div>

            <div className="form-group">
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Hai già esperienza con i cani? *</label>
              <select style={{ width: '100%', padding: '16px', border: '1px solid #ddd', borderRadius: '12px', fontFamily: 'var(--font-secondary)' }} required>
                <option value="">Seleziona il tuo livello di esperienza...</option>
                <option value="avanzata">Sì, sono un educatore/professionista cinofilo</option>
                <option value="volontariato_passato">Sì, ho già fatto volontariato in altri canili</option>
                <option value="proprietario">Sì, ho condiviso gran parte della vita con cani miei</option>
                <option value="poca">Ho avuto qualche interazione, ma non ho molta esperienza pratica</option>
                <option value="nessuna">Nessuna esperienza, ma tanta voglia di imparare e aiutare!</option>
              </select>
            </div>

            <div className="form-group">
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Perché vuoi fare volontariato da noi?</label>
              <textarea placeholder="Raccontaci qualcosa di te..." style={{ minHeight: '120px' }}></textarea>
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '16px', fontSize: '18px', marginTop: '16px' }}>
              Invia la tua Candidatura
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default VolunteerPage;
